import { createAsyncThunk } from "@reduxjs/toolkit";

import { getProjectActivityRequest } from "Api/activity/getProjectActivity.request";
import logger from "Libs/logger";
import { AsyncThunkOptionType } from "Reducers/types";

import type { Activity } from "Api/activity/types";
import type { LoadProjectActivity } from "../types";

export const loadProjectActivity = createAsyncThunk<
  Activity,
  LoadProjectActivity,
  AsyncThunkOptionType
>(
  "app/activity/project/load_one",
  async (
    { organizationDescriptionId, projectDescriptionId, activityId },
    { rejectWithValue }
  ) => {
    try {
      return await getProjectActivityRequest({
        projectId: projectDescriptionId,
        activityId: activityId
      });
    } catch (err) {
      if (![404, 403].includes((err as { code: number }).code)) {
        logger(err, {
          action: "app/activity/project/load_one",
          meta: {
            organizationDescriptionId,
            projectDescriptionId,
            activityId
          }
        });
      }

      return rejectWithValue(err);
    }
  }
);
